import { render, staticRenderFns } from "./WorkTypes.vue?vue&type=template&id=3dff71eb&"
import script from "./WorkTypes.vue?vue&type=script&lang=js&"
export * from "./WorkTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports